<template>
  <button
    class="invisible-btn add-to-favorites-btn"
    @click="toggleFavourites"
  >
    <TagIcon
      v-if="!isAdded"
      :icon="HeartEmptyIcon"
      color="mono-black"
      class="mr-2 h-5 w-5"
    />
    <TagIcon
      v-if="isAdded"
      :icon="HeartFullIcon"
      color="brand-secondary-dark"
      class="mr-2 h-5 w-5"
    />

    <span class="font-semibold text-grey-600">
      {{ label }}
    </span>
  </button>
</template>

<script>
import HeartFullIcon from '@tagvenue/icons/24/bold/general/heart-rounded.svg';
import HeartEmptyIcon from '@tagvenue/icons/24/line/general/heart-rounded.svg';
import { markRaw } from 'vue';

import TagIcon from '@/components/TagIcon.vue';

export default {
  name: 'AddToFavouritesSmall',
  components: { TagIcon },

  data() {
    return {
      HeartEmptyIcon: markRaw(HeartEmptyIcon),
      HeartFullIcon: markRaw(HeartFullIcon),
    };
  },

  computed: {
    label() {
      return this.isAdded ? 'Saved' : 'Save';
    },
    isAdded() {
      return this.$store.state.wishlist.isRoomFavourite;
    },
  },

  methods: {
    toggleFavourites() {
      this.$store.dispatch('wishlist/toggleWishlist');
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@sass/design-system/variables' as ds-variables;

.invisible-btn {
  align-items: center;
  display: flex;
  border: none;
  background: transparent;
  padding: 8px 20px;
  border-radius: 6px;
  transition: all 0.3s;
  transition-property: background-color, color, border-color;

  &:hover {
    background: ds-variables.$grey-100;
  }
  &:active {
    background: ds-variables.$grey-200;
  }
}

.add-to-favorites-btn {
  min-width: 110px;
}
</style>
